import { jwtDecode } from 'jwt-decode';

const EMPTY = { userId: null, roles: [] };

export default function decodeToken(token) {
  try {
    const { userId, roles } = jwtDecode(token);

    return { userId: userId || null, roles: Array.isArray(roles) ? roles : [] };
  } catch {
    return EMPTY;
  }
}
